/* cf-quote-editor-bind.js - Click Fencing, 2026-08-15
 *
 * Keeps the quote editor bound to the quote the review page is actually showing.
 *
 * cf-quote-editor.js resolves the on-screen quote from the highlighted .qr-quote-pill, but
 * it installs before quote-review.js has rendered the pills - so on first load it can bind
 * to a different quote than the one displayed. Observed live: the page showed "PerfMesh
 * Quote 3" while the editor was bound to "Frameless Glass Quote 16" and showed that
 * quote's lines and total.
 *
 * A pill CLICK is already handled inside the editor, which tears down and rebuilds against
 * whatever is then active. So the cheapest correct repair for the initial race is to
 * re-click the pill that is already active: quote-review.js re-selects the quote it is
 * already showing (a visual no-op) and the editor rebinds itself. No editor change needed.
 *
 * Deliberately a separate file: the editor is a large, working asset and this is a timing
 * guard, so it stays independently reviewable and removable.
 *
 * Load AFTER cf-quote-editor.js.
 */
(function () {
  'use strict';
  if (window.__cfQuoteBindInstalled) return;
  window.__cfQuoteBindInstalled = true;

  var CALCS = ['ullc', 'blade', 'flattop', 'perfmesh'];
  var repairs = 0;

  /* Only act if a quote matching the pill actually exists - otherwise a label we cannot
     satisfy would make this re-click for ever. */
  function quoteExistsNamed(label) {
    for (var i = 0; i < CALCS.length; i++) {
      var c = CALCS[i];
      try {
        var act = JSON.parse(localStorage.getItem(c + '_active_quote') || 'null');
        if (act && act.breakdown && String(act.quoteName || '').trim() === label) return true;
      } catch (e) {}
      try {
        var arr = JSON.parse(localStorage.getItem(c + '_quotes') || '[]') || [];
        for (var j = 0; j < arr.length; j++) {
          if (arr[j] && arr[j].breakdown && String(arr[j].quoteName || '').trim() === label) return true;
        }
      } catch (e) {}
    }
    return false;
  }

  function check() {
    try {
      if (!/quote-review/.test(location.pathname)) return;
      if (!document.querySelector('.cf-qe')) return;
      var pill = document.querySelector('.qr-quote-pill.is-active');
      var label = pill ? String(pill.textContent || '').trim() : '';
      if (!label) return;
      var st = window.__cfQuoteState;
      var bound = st && st.quote ? String(st.quote.quoteName || '').trim() : '';
      if (!bound || bound === label) return;
      if (!quoteExistsNamed(label)) return;
      if (repairs++ > 5) return;
      console.log('[cf-quote-editor-bind] rebinding "' + bound + '" -> "' + label + '"');
      pill.click();
    } catch (e) {}
  }

  /* Poll briefly rather than observing: quote-review.js re-renders the pill container
     wholesale, so an observer on it would be detached on the first swap anyway. */
  var n = 0;
  var id = setInterval(function () {
    check();
    if (++n > 40) clearInterval(id);
  }, 500);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
})();
